import React from 'react';
import { Check, ArrowRight } from 'lucide-react';

export default function Success() {
  return (
    <div className="min-h-screen bg-[#111315] text-white">
      {/* Header */}
      <nav className="border-b border-neutral-800 bg-[#111315]/95 backdrop-blur-xl">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center">
              <img src="/logo.png" alt="HDAlgos logo" className="h-10 w-auto" />
              <span className="sr-only">HDAlgos Institutional Systems</span>
            </div>
          </div>
        </div>
      </nav>

      {/* Success Content */}
      <div className="flex items-center justify-center px-6 py-20">
        <div className="max-w-2xl text-center">
          {/* Success Icon */}
          <div className="relative mb-8">
            <div className="w-32 h-32 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center mx-auto shadow-xl shadow-green-500/20">
              <Check className="w-16 h-16 text-white" strokeWidth={3} />
            </div>
            <div className="absolute inset-0 bg-green-500/20 rounded-full blur-3xl"></div>
          </div>

          {/* Success Message */}
          <h1 className="text-5xl md:text-6xl font-black mb-6">
            Payment Successful!
          </h1>

          <p className="text-xl text-neutral-300 mb-4">
            Welcome to HDAlgos Institutional Systems
          </p>

          <p className="text-neutral-400 mb-12 max-w-xl mx-auto leading-relaxed">
            Your subscription has been activated. Check your email for login credentials, setup instructions, and next steps to access your dashboard.
          </p>

          {/* What's Next */}
          <div className="bg-neutral-950 ring-1 ring-neutral-800 rounded-xl p-8 mb-12 text-left max-w-lg mx-auto">
            <h2 className="text-xl font-bold mb-6 text-center">What's Next?</h2>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-[#CBB26A]/20 ring-1 ring-[#CBB26A]/50 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-[#CBB26A] text-sm font-bold">1</span>
                </div>
                <div>
                  <div className="font-semibold text-white mb-1">Check Your Email</div>
                  <div className="text-sm text-neutral-400">
                    We've sent you a confirmation email with your account details and login instructions.
                  </div>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-[#CBB26A]/20 ring-1 ring-[#CBB26A]/50 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-[#CBB26A] text-sm font-bold">2</span>
                </div>
                <div>
                  <div className="font-semibold text-white mb-1">Access Your Dashboard</div>
                  <div className="text-sm text-neutral-400">
                    Log in to your personalized dashboard to view all your subscribed systems.
                  </div>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-[#CBB26A]/20 ring-1 ring-[#CBB26A]/50 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-[#CBB26A] text-sm font-bold">3</span>
                </div>
                <div>
                  <div className="font-semibold text-white mb-1">Explore the Documentation</div>
                  <div className="text-sm text-neutral-400">
                    Review our comprehensive guides to get the most out of your systems.
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/"
              className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-[#CBB26A] to-[#A8914D] text-black px-10 py-4 rounded-lg font-black text-lg hover:from-[#D8C585] hover:to-[#BDA45E] transition transform hover:scale-105 shadow-xl shadow-[#CBB26A]/20"
            >
              Return to Home
              <ArrowRight className="w-5 h-5" />
            </a>
            <a
              href="/system-library"
              className="inline-flex items-center justify-center gap-2 ring-1 ring-neutral-700 px-10 py-4 rounded-lg font-bold text-lg hover:ring-[#CBB26A] hover:text-[#CBB26A] transition"
            >
              View System Library
            </a>
          </div>

          {/* Support Notice */}
          <div className="mt-12 bg-[#CBB26A]/10 ring-1 ring-[#CBB26A]/30 rounded-lg p-6">
            <p className="text-sm text-neutral-400">
              Need help getting started? Contact our support team at{' '}
              <a href="mailto:support@hdalgos.com" className="text-[#CBB26A] hover:text-[#CBB26A] font-semibold">
                support@hdalgos.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
